(function () {
    'use strict';

    angular
        .module('app.user')
        .component('ubStepWizardTrucks', {
            bindings: {              
                model: '<',
                disabled: '<',
                onTruckAccessChanged: '&',
                onValidationChange: '&'
            },
            controller: UserOnboardingStepWizardTrucks,
            controllerAs: 'vm',
            templateUrl: 'app/user/dashboard/onboard/wizard/step-trucks/user.onboard.wizard.trucks.html'
        });

    /*jshint -W071, -W072 */
    /* @ngInject */
    function UserOnboardingStepWizardTrucks(truckService) {

        var vm = this;
        vm.$onInit = onInit();

        vm.loading = false;

        vm.page = 1;
        vm.pageCount = 10;
        vm.count = 0;
      
        vm.trucks = [];

        vm.loadMoreVins = loadMoreVins;
        vm.validate = validate;
        //vm.onAccessTypeChanged = onAccessTypeChanged;

        function onInit() {         
        }
       
        function loadMoreVins(select, event) {
            
            vm.loading = true;
            if (event) {
                event.stopPropagation();
                event.preventDefault();
                vm.page = vm.page + 1;
            } else {
                vm.count = 0;
                vm.page = 0;                
                vm.trucks = !!vm.model.Vins ?
                    vm.model.Vins.map(function (vin) {
                        return { ShortVIN: vin };
                    })
                    : [];
            }

            return getTrucks(select.search, vm.page, vm.pageCount).then(function (results) {
                vm.count = results.count;
                vm.trucks = vm.trucks.concat(results);
                vm.loading = false;
                return results;
            });
        }

        function getTrucks(searchTerm, page, pageCount) {
            return truckService.getAllTruckVins(searchTerm, page, pageCount).then(function (results) {
                return results;                
            });
        }

        //function onAccessTypeChanged() {
        //    if (vm.model.AccessType === 0) {
        //        vm.model = angular.extend(vm.model, { Vins: [] });
        //    }

        //    vm.onTruckAccessChanged({ accessType: vm.model.AccessType });
        //    validate();
        //}

        function validate() {
            var isValid = vm.model.Vins.length > 0;
                       
            vm.onValidationChange({ isValid: isValid });
        }
    }
})();
